import { Button } from '@mui/material';
import { SavedThumbnail } from '../../../../data/atom';
import { ANALYSIS_STATUS, ON_KIDS_ANALYSIS_THUMBNAIL } from '../../../../data/define';
import ImgNoThumbnail from '../../../../assets/image/fallback_thumbnail.png';
import IcCloseB from '../../../../assets/image/ic_x.svg';
import type { AnalysisLocationState } from '../index';

interface AnalysisErrorViewProps {
  status: string;
  state: AnalysisLocationState | null;
  savedThumbnail: SavedThumbnail;
  onClose: () => void;
  onReRegister: () => void;
}

export default function AnalysisErrorView({
  status,
  state,
  savedThumbnail,
  onClose,
  onReRegister,
}: AnalysisErrorViewProps) {
  return (
    <>
      <div
        className="pageInner flex flex-col items-center justify-end"
        style={{ paddingBottom: '0' }}
      >
        <div className="w-full flex justify-end py-[20px] h-[66px] shrink-0">
          <button type="button" onClick={onClose}>
            <img src={IcCloseB} alt="Close" />
          </button>
        </div>
        <div className="text-[24px] font-[700] min-h-[100px] h-auto text-center py-3">
          {status === ANALYSIS_STATUS.NOTHING ? (
            <>
              포착된 재능이 없어요
              <br />
              다른 영상을 업로드 해주세요
            </>
          ) : (
            <>
              영상을 분석하지 못했어요
              <br />
              가이드를 다시 확인해 주세요
            </>
          )}
        </div>
        <div className="grow w-full flex flex-col items-center justify-center rounded-[10px] overflow-hidden">
          <img
            src={
              state?.thumbnail ||
              savedThumbnail?.thumbnail ||
              sessionStorage.getItem(ON_KIDS_ANALYSIS_THUMBNAIL) ||
              ImgNoThumbnail
            }
            alt="Selected"
            className="object-cover max-h-full w-full h-full"
          />
        </div>
      </div>
      <div
        className="flex p-5 justify-between gap-3 w-full items-center bg-white"
        style={{ zIndex: 1000 }}
      >
        <Button variant="outlined" className="grow" onClick={onReRegister}>
          재등록
        </Button>
      </div>
    </>
  );
}
